/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import './member.scss';
import MemberDetailsInfo from './MemberDetailsInfo';
import MemberList from '../../api/MemberList';
import APIEndpoints from '../../api/APIEndpoints';
import CookiesService from '../../shared/CookiesService';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import RetryAPI from '../../api/RetryAPI';
import useDate from '../../utils/useDate';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NoDataFound from '../common/NoDataFound';
import { axiosInstance } from '../../../api/axios';
import AllMemberSkeleton from './Skeleton/AllMemberSkeleton';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from 'src/Admin/components/common/CustomPagination';
import { capitalizeFirstLetter } from '../../utils/strings';
import CustomClientError from '../../errorhandling/CustomClientError';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
const noValue = 'NA';

const RegisteredMember = (props) => {
  //const navigate = useNavigate();
  const [memberListData, setMemberListData] = useState();
  const [loadingMemberList, setLoadingMemberList] = useState(true);
  const [serverError, setServerError] = useState(false);
  const [clientError, setClientError] = useState(false);
  const [userIndex, setUserIndex] = useState(0);
  const [userEmail, setUserEmail] = useState('');
  const [searchText, setSearchText] = useState(props.searchText);
  //const [ pageSize, setPageSize ] = useState( 10 );
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedPageCnt, setSelectedPageCnt] = useState(10);
  const [itemsPerPageStart, setItemsPerPageStart] = useState(1);
  const [totalCount, setTotalCount] = useState(-1);
  const [memberUpdated, setMemberUpdated] = useState(0);
  const [loadingMemberPage, setLoadingMemberPage] = useState(true);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [preservePageNumber, setPreservePageNumber] = useState(true);
  const [preservePageSize, setPreservePageSize] = useState(true);
  const [preserveSelectedIndex, setPreserveSelectedIndex] = useState(true);
  const [activePage, setActivePage] = useState(
    preservePageSize
      ? props?.selectedInfo?.activePage && props?.selectedInfo?.isRegistered
        ? props?.selectedInfo?.activePage
        : 1
      : 1,
  );
  const [pageSize, setPageSize] = useState(
    preservePageNumber
      ? props?.selectedInfo?.pageSize && props?.selectedInfo?.isRegistered
        ? props?.selectedInfo?.pageSize
        : 10
      : 10,
  );
  const [itemsPerPageEnd, setItemsPerPageEnd] = useState(pageSize);
  const { formatDate } = useDate();
  const displayPaginationMininumCount = 10;
  let SearchMemberListDataResp = null;
  console.log('props.selectedInfo', props.selectedInfo);
  //Preserve State
  useEffect(() => {
    if (props.selectedInfo != undefined && props?.selectedInfo?.isRegistered) {
      if (preservePageSize && pageSize != props.selectedInfo.pageSize) {
        setPageSize(props.selectedInfo.pageSize);
      }
      if (preservePageNumber && activePage != props.selectedInfo.activePage) {
        setActivePage(props.selectedInfo.activePage);
      }

      if (memberListData?.User?.length > 0) {
        if (preserveSelectedIndex) {
          if (
            preservePageNumber &&
            memberListData?.Pagination?.PageNumber ==
              props.selectedInfo.activePage
          ) {
            selectingUserDynamically(
              props.selectedInfo.userIndex,
              memberListData,
            );
          }
        } else {
          selectingUserDynamically(0, memberListData);
        }
      }
    }
  }, [props.selectedInfo, memberListData]);

  //To make page size and number to initial state when something changes in search string.
  useEffect(() => {
    if (props.putDataInitialState && preservePageNumber && preservePageSize) {
      setPreserveSelectedIndex(false);
      setPreservePageNumber(false);
      setActivePage(1);
      if (props.resetPageSize) {
        setPageSize(10);
      }
      if (memberListData?.length > 0) {
        selectingUserDynamically(0, memberListData);
      }
    }
  }, [props.putDataInitialState, memberListData]);

  useEffect(() => {
    const { bob, employer, location } = props;

    const globalFilter = () => {
      let strFilter = '';
      if (bob && bob !== 'all') {
        strFilter += `/blkofbusoid/${bob}`;
      }
      if (employer && employer !== 'all') {
        strFilter += `/clientoid/${employer}`;
      }
      if (location && location !== 'all') {
        strFilter += `/locationoid/${location}`;
      }
      return strFilter;
    };

    const searchMemberList = async () => {
      //eslint-disable-next-line prefer-const
      let bearerToken = '',
        //refreshToken = '',
        SearchMemberListAPI = '';
      SearchMemberListAPI = '';
      bearerToken = CookiesService.get('loginToken');

      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        try {
          let strSearchText = '';
          if (props.searchText) {
            strSearchText = `SearchKey/${props.searchText}/`;
          }

          const SearchMemberListResponse = await axiosInstance.get(
            cacheBuster(
              APIEndpoints.getRegisterdMemberListResources() +
                strSearchText +
                'PageSize/' +
                pageSize +
                '/PageNumber/' +
                activePage +
                globalFilter(),
            ),
          );

          SearchMemberListDataResp = await SearchMemberListResponse.data;
          if (
            SearchMemberListResponse.status ==
            HttpSuccessCodes.HTTP_SUCCESS_CODE_200 //&&
            //props.selectedSearchTypeRadioBtn === 'primarySearch'
          ) {
            console.log(SearchMemberListDataResp, 'SearchMemberListDataResp');
            MemberList.setMemberListResp(SearchMemberListDataResp);
            RetryAPI.resetRetryCount();
            RetryAPI.setResponseReceived(true);
            console.log('Successful Search memberListData: ', memberListData);
            console.log(
              'Successful SearchMemberListResponse: ',
              SearchMemberListDataResp.Response,
            );
            setMemberListData(SearchMemberListDataResp.Response);
            MemberList.setTotalRecords(
              SearchMemberListDataResp.Response.Pagination.TotalRecords,
            );
            if (
              SearchMemberListDataResp.Response.User &&
              SearchMemberListDataResp.Response.User?.length > 0
            ) {
              console.log('Successful Search memberListData: ', memberListData);
              MemberList.setSelectedUser(
                SearchMemberListDataResp.Response.User[0],
              );
              MemberList.setFirstUser(
                SearchMemberListDataResp.Response.User[0],
              );
              MemberList.setTotalRecords(
                SearchMemberListDataResp.Response.Pagination.TotalRecords,
              );
              const start =
                pageSize * (activePage - 1) +
                (MemberList.getTotalRecords ? 1 : 0);
              let end = start + pageSize - 1;
              if (end > MemberList.getTotalRecords()) {
                end = MemberList.getTotalRecords();
              }
              setItemsPerPageStart(start);
              setItemsPerPageEnd(end);
              setTotalCount(
                SearchMemberListDataResp.Response.Pagination.TotalRecords,
              );
            } else {
              setTotalCount(0);
              MemberList.setSelectedUser(null);
            }
          } else {
            RetryAPI.incrementRetryCount();
            RetryAPI.setResponseReceived(false);
            RetryAPI.setErrorCode(SearchMemberListResponse.status);
            console.log(
              'Search User List Error code:',
              SearchMemberListResponse.status,
            );
          }
          setIsNotFound(false);
          setIsAPIFailed(false);
          if (RetryAPI.getResponseReceived()) break;
        } catch (error) {
          let errorMessage = '';
          setIsAPIFailed(true);
          setLoadingMemberList(false);
          if (error.toString().includes('404')) {
            setIsNotFound(true);
          }

          if (error) {
            errorMessage = error.toString();
            //requestAborted = errorMessage.match(/aborted/i);
            RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
          }
          if (error.response) {
            RetryAPI.setErrorCode(error.response.status);
          }

          RetryAPI.incrementRetryCount();
          RetryAPI.setResponseReceived(false);
        }
      }

      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view Member lists. ',
          )
        ) {
          //Display Error Message -No claims submitted in the past six months.
          setClientError(true);
          setLoadingMemberList(false);
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Member List now.',
            )
          ) {
            setServerError(true);
          }
        }
      } else {
        setLoadingMemberList(false);
        setLoadingMemberPage(false);
      }
    };
    setLoadingMemberList(true);
    if (
      props.selectedInfo != undefined &&
      props?.selectedInfo?.isRegistered &&
      preservePageNumber &&
      preservePageSize
    ) {
      if (
        activePage == props.selectedInfo.activePage &&
        pageSize == props.selectedInfo.pageSize
      ) {
        //Note: Due to api failure implemented functional call through setTimeout(). Need to refactor infuture
        //searchMemberList();
        setTimeout(() => {
          searchMemberList();
        }, 500);
      }
    } else {
      setTimeout(() => {
        searchMemberList();
      }, 500);
      //Note: Due to api failure implemented functional call through setTimeout(). Need to refactor infuture
      //searchMemberList();
    }
    setUserIndex(0);
  }, [
    props.searchText,
    props.bob,
    props.employer,
    props.location,
    activePage,
    pageSize,
  ]);

  useEffect(() => {
    const { bob, employer, location } = props;

    const globalFilter = () => {
      let strFilter = '';
      if (bob && bob !== 'all') {
        strFilter += `/blkofbusoid/${bob}`;
      }
      if (employer && employer !== 'all') {
        strFilter += `/clientoid/${employer}`;
      }
      if (location && location !== 'all') {
        strFilter += `/locationoid/${location}`;
      }
      return strFilter;
    };
    const UpdateMemberList = async () => {
      let strSearchText = '';
      if (props.searchText) {
        strSearchText = `SearchKey/${props.searchText}/`;
      }
      const SearchMemberListResponse = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getRegisterdMemberListResources() +
            strSearchText +
            'PageSize/' +
            pageSize +
            '/PageNumber/' +
            activePage +
            globalFilter(),
        ),
      );
      SearchMemberListDataResp = await SearchMemberListResponse.data;
      if (
        SearchMemberListResponse.status ==
        HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        MemberList.setMemberListResp(SearchMemberListDataResp);
        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
        setMemberListData(SearchMemberListDataResp.Response);
        if (
          SearchMemberListDataResp.Response.User &&
          SearchMemberListDataResp.Response.User?.length > 0
        ) {
          MemberList.setSelectedUser(
            userIndex
              ? SearchMemberListDataResp.Response.User[userIndex]
              : SearchMemberListDataResp.Response.User[0],
          );
          MemberList.setFirstUser(SearchMemberListDataResp.Response.User[0]);
        } else {
          setTotalCount(0);
          MemberList.setSelectedUser(null);
        }
        setIsAPIFailed(false);
        setIsNotFound(false);
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(SearchMemberListResponse.status);
      }
      try {
        RetryAPI.getResponseReceived();
      } catch (error) {
        let errorMessage = '';
        setIsAPIFailed(true);
        setLoadingMemberList(false);
        if (error.toString().includes('404')) {
          setIsNotFound(true);
        }

        if (error) {
          errorMessage = error.toString();
          //requestAborted = errorMessage.match(/aborted/i);
          RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
        }
        if (error.response) {
          RetryAPI.setErrorCode(error.response.status);
        }

        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
      }
      if (RetryAPI.retryFailed()) {
        const errorCode = RetryAPI.getErrorCode();
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view Member lists. ',
          )
        ) {
          //Display Error Message -No claims submitted in the past six months.
          setClientError(true);
          setLoadingMemberList(false);
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Member List now.',
            )
          ) {
            setServerError(true);
          }
        }
      } else {
        setLoadingMemberList(false);
        setLoadingMemberPage(false);
      }
    };

    Boolean(memberUpdated) && UpdateMemberList();
  }, [memberUpdated]);

  const selectingUserDynamically = (index, memberListInfo) => {
    console.log('function call: ', index);
    MemberList.setSelectedUser(memberListInfo.User[index]);
    setUserIndex(index);
  };

  const renderMemberManagementInfo = () => {
    let selectedUser = null;
    selectedUser = MemberList.getSelectedUser();
    let userEmail = null;
    console.log('renderMemberManagementInfo: ', selectedUser);

    if (selectedUser != null) {
      userEmail = selectedUser.UserEmail;
      const UserOid = selectedUser.UserOid;
      console.log(
        'CALLING FROM UserManagement Index: ',
        selectedUser.UserEmail,
      );
      return (
        <MemberDetailsInfo
          {...props}
          pageSize={pageSize}
          activePage={activePage}
          isRegisterd={true}
          userEmail={userEmail}
          uoid={UserOid}
          userIndex={userIndex}
          updateCallback={memberUpdatedCallback}
          updateSelectedMemberEmailID={updateSelectedMemberEmailID}
          infoUpdated={memberUpdated}
        />
      );
    }
  };

  //let eventlist;
  const ListUser = (event, index) => {
    console.log('function call: ', index);
    //eventlist = event;
    console.log(event, index, 'event');
    MemberList.setSelectedUser(event);
    setUserIndex(index);
  };
  //pagination specific handler
  const pageSizeHandler = useCallback((pageSizeInfo) => {
    setActivePage(1);
    setPageSize(pageSizeInfo.value);
    setPreservePageSize(false);
    setPreserveSelectedIndex(false);
    //eslint-disable-next-line
  }, []);

  const memberUpdatedCallback = () => {
    setMemberUpdated(memberUpdated + 1);
  };

  const updateSelectedMemberEmailID = (selectedIndex, emailId) => {
    const updatedMemberData = { ...memberListData };
    updatedMemberData.User[selectedIndex].UserEmail = emailId;
    setMemberListData(updatedMemberData);
  };

  const PaginationTab = () => (
    <>
      {totalCount > displayPaginationMininumCount ? (
        <CustomPagination
          siblingCount={1}
          className="memberManagePagination"
          pageSize={pageSize}
          currentPage={activePage}
          totalCount={totalCount}
          onPageChange={(page) => {
            setActivePage(page);
            setPreservePageNumber(false);
            setPreserveSelectedIndex(false);
          }}
        />
      ) : null}
    </>
  );

  return (
    <div>
      {loadingMemberList && <AllMemberSkeleton />}

      <div>
        {!loadingMemberList &&
        !clientError &&
        totalCount > displayPaginationMininumCount ? (
          <div className="table-footer">
            <CustomPaginationItemsDisplay
              pageSize={pageSize}
              setPageSize={pageSizeHandler}
              className="top-pagination"
              prefixMessage="Records per page"
              suffixMessage={`Showing ${itemsPerPageStart} - ${itemsPerPageEnd} of ${totalCount} results`}
            />
            <PaginationTab />
          </div>
        ) : null}
      </div>

      {!loadingMemberList && isAPIFailed ? (
        <Container className="px-0">
          {isNotFound ? (
            <CustomClientError
              CustomClasses="p-0"
              ErrorHeading="No Members found!"
              ErrorMessage="No Member found. We are unable to render member list for given search. "
            />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
            />
          )}
        </Container>
      ) : (
        <Row>
          <Col>
            <Tab.Container id="left-tabs-example" defaultActiveKey="1">
              {!loadingMemberList && totalCount > 0 ? (
                <Row className="mar-top-30">
                  <Col sm={4}>
                    <div>
                      <div className="scroll">
                        <Nav
                          variant="pills"
                          className="flex-column usergrpTabs member-mgt nav nav-pills"
                        >
                          {memberListData && (
                            <div>
                              {memberListData.User.map((memberlist, index) => (
                                <Nav.Item
                                  onClick={(e) => ListUser(memberlist, index)}
                                  className="User-list-margin"
                                  key={`user-list-${index}`}
                                >
                                  <Nav.Link
                                    className={
                                      userIndex === index ? 'active' : null
                                    }
                                  >
                                    <Row>
                                      <Col md={2} className="user-icon">
                                        <span className="mgt-user-icon-img ">
                                          {memberlist.FirstName.charAt(0) +
                                            memberlist.LastName.charAt(0)}
                                        </span>
                                      </Col>
                                      <Col
                                        md={6}
                                        className="padding-0 registered-username"
                                      >
                                        {/*<h5> */}
                                        <label>
                                          {capitalizeFirstLetter(
                                            memberlist.FirstName,
                                          )}{' '}
                                          {capitalizeFirstLetter(
                                            memberlist.LastName,
                                          )}
                                        </label>
                                        {/*</h5> */}
                                        <p>{memberlist.UserEmail}</p>
                                      </Col>
                                      <Col>
                                        <p className="text-right">
                                          <span
                                            className={
                                              memberlist.Status === 'Active'
                                                ? 'user-active'
                                                : 'inactive'
                                            }
                                          >
                                            {memberlist.Status}
                                          </span>
                                        </p>
                                      </Col>
                                    </Row>
                                    <Row className="usertabs-bottom">
                                      <Col>
                                        <p>User Type: {memberlist.UserType}</p>
                                      </Col>
                                      <Col>
                                        <p className="text-right">
                                          Created :{' '}
                                          {memberlist.CreatedDate
                                            ? formatDate(memberlist.CreatedDate)
                                            : noValue}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Nav.Link>
                                </Nav.Item>
                              ))}
                            </div>
                          )}
                        </Nav>
                        <Row className="margin-10 usermanagement-pagination">
                          {totalCount > displayPaginationMininumCount ? (
                            <div className="memberManagePage">
                              <CustomPaginationItemsDisplay
                                prefixMessage="Records per page"
                                pageSize={pageSize}
                                setPageSize={pageSizeHandler}
                              />
                              <div>
                                <PaginationTab />
                              </div>
                            </div>
                          ) : null}
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col sm={8}>{renderMemberManagementInfo()}</Col>
                </Row>
              ) : (
                !loadingMemberList &&
                totalCount === 0 && (
                  <Row>
                    <Col>
                      <CustomClientError
                        ErrorHeading="No Members found!"
                        ErrorMessage="No Member found. We are unable to render member list for given search. "
                      />
                    </Col>
                  </Row>
                )
              )}
            </Tab.Container>
          </Col>
        </Row>
      )}

      {/*<div className="toastify">
        <ToastContainer
          position="top-center"
          className="toastcontainer"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div> */}
    </div>
  );
};

export default RegisteredMember;
